if (!customElements.get('dynamic-collection')) {
    class DynamicCollection extends HTMLElement {
        constructor() {
            super();
            this.selector = {
                main: this.querySelector('#dynamic-collection')
            };
            this.state = {
                isDown: false,
                startX: null,
                scrollLeft: null
            };
            this.load();
        }
     load() {
        if(this.selector.main) {
                /* T6.25b: the sort dropdown is optional now. Without it, load the collection's
                   own default order (data-sort-by), e.g. the Trending Products ranking. */
                const sortBy = this.selector.main.querySelector('.dynamic-collection-sort-by');
                const container = this.selector.main.querySelector('.dynamic-collection-container');
                const sortValue = () => (sortBy ? sortBy.value : (this.selector.main.dataset.sortBy || ''));
                this.render(container, this.selector.main.dataset.collectionHandle, sortValue());
                if (sortBy) {
                    sortBy.addEventListener('change', () => {
                        this.render(container, this.selector.main.dataset.collectionHandle, sortValue());
                    });
                }
                this.selector.main.addEventListener('click', event => {
                    if(event.target.closest('.colour-swatch-label')) {
                        const variantImages = event.target.closest('.spf-product-card__inner').querySelectorAll('img.spf-product-card__image');
                        event.target.closest('.spf-product-card__inner').querySelector('.product-tile__image-container > .spf-product-card__image-wrapper').href = event.target.closest('.colour-swatch-label').dataset.variantUrl;
                        if(variantImages.length > 1) {
                            variantImages.forEach((image,index) => {
                                if(event.target.closest('.colour-swatch-label').dataset.colourValue === image.dataset.colourHandle) {
                                    if(index == 1) {
                                        variantImages[1].classList.remove('spf-product-card__image-secondary');
                                        variantImages[0].classList.add('spf-product-card__image-secondary');
                                    } else {
                                        variantImages[1].classList.add('spf-product-card__image-secondary');
                                        variantImages[0].classList.remove('spf-product-card__image-secondary');
                                    }
                                    image.classList.add('spf-product-card__image-main');
                                    image.classList.remove('spf-product-card__image-hidden');
                                } else {
                                    image.classList.add('spf-product-card__image-hidden');
                                    image.classList.remove('spf-product-card__image-main');
                                }
                            })
                        }
                }
                })
            }     
        }
        async render(container, collectionHandle, sortValue) {
            await fetch(`/collections/${collectionHandle}?section_id=dynamic-collection-inner${sortValue ? `&sort_by=${encodeURIComponent(sortValue)}` : ''}`)
              .then(result => result.text())
              .then(html => {
                const temp = document.createElement('div');
                temp.innerHTML = html;
                container.innerHTML = '';
                container.append(temp.children[0].children[0]);
              })
              .catch(error => {
                console.error(error);
              })
              .finally(() => {
                const dynamicInner = this.querySelector('.dynamic-collection-inner');
                if (dynamicInner) {
                    dynamicInner.addEventListener('mousedown', event => {
                        this.state.isDown = true;
                        dynamicInner.classList.add('active');
                        this.state.startX = event.pageX - dynamicInner.offsetLeft;
                        this.state.scrollLeft = dynamicInner.scrollLeft;
                    });
    
                    dynamicInner.addEventListener('mouseleave', event => {
                        this.state.isDown = false;
                        dynamicInner.classList.remove('active');
                    });
    
                    dynamicInner.addEventListener('mouseup', event => {
                        this.state.isDown = false;
                        dynamicInner.classList.remove('active');
                        if(event.target.closest('.colour-swatch-label') || event.target.closest('.featured-quick-view-modal-btn') || event.target.closest('.spf-product-card__image-wrapper')) return;
                    });
    
                    dynamicInner.addEventListener('mousemove', event => {
                        if(!this.state.isDown) return;
                        event.preventDefault();
                        const x = event.pageX - dynamicInner.offsetLeft;
                        const walk = (x - this.state.startX) * 2;
                        const newScrollLeft = this.state.scrollLeft - walk;
                        dynamicInner.scrollLeft = newScrollLeft;
                    });
                }
              });
        }
    }
   customElements.define('dynamic-collection', DynamicCollection);
}